import { Trans, useTranslation } from '@cobliteam/i18n';
import Typography from '@cobliteam/ui/components/Typography';
import HelpPopover from './HelpPopover';

interface CounterProps {
  shown: number;
  total: number;
  onHelpOpen?: () => void;
}

export const Counter = ({ shown, total, onHelpOpen }: CounterProps) => {
  useTranslation('drivers');
  return (
    <div className='flex items-center gap-2'>
      <Typography variant='text-sm' color='secondary'>
        <Trans i18nKey='drivers:face_id.selector.count' values={{ shown, total }} components={{ bold: <strong /> }} />
      </Typography>
      <HelpPopover onOpen={onHelpOpen} />
    </div>
  );
};

export default Counter;
